import * as React from 'react';

import { Watch } from 'scrollmonitor-react';

import './articleTwoColText.scss';
 

class ArticleTwoColText extends React.Component {
  render() {
    let theBlock = this.props.block;
    let inView = this.props.isInViewport;
    let elementHasBeenInView = this.props.isAboveViewport;
    let displaySingleCol = theBlock.displaySingleCol ? true : false;

    // Change classname based on boolean
    let viewClassName = (inView)? 'is-inview-true' : 'is-inview-false';
    let beenViewed = (elementHasBeenInView)? ' is-viewed' : ' is-not-viewed';


    return (
        <div className={theBlock.blockHideOnMobile ? viewClassName + beenViewed + " d-none d-md-block " + theBlock.blockType : viewClassName + beenViewed + " " + theBlock.blockType}> 
        <div className="container"> 
            <div className="row">
                <div className="col-12 mb-sm-4">
                    <div className="row">
                    {!displaySingleCol &&
                        <div className="col-md-4 offset-md-2">
                            <div dangerouslySetInnerHTML={{__html: theBlock.blockHtmlOne}} />
                        </div>
                    }
                    {!displaySingleCol &&
                        <div className="col-md-4 offset-md-1">
                            <div dangerouslySetInnerHTML={{__html: theBlock.blockHtmlTwo}} />
                        </div>
                    }
                    {displaySingleCol &&
                        <div className="col-md-9 offset-md-2">
                            <div dangerouslySetInnerHTML={{__html: theBlock.blockHtmlOne + theBlock.blockHtmlTwo}} />
                        </div> 
                    }
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
  }
}

//const InviewOptions = {offsetY: 0.2, showGuides: false, fullElementInView: false, debounceTime: 30}

export default Watch(ArticleTwoColText);
